'use strict';

import {
    changeBorderRadius,
    createElements,
    createHtmlElement,
    get_url_param,
    getUrlParam,
    numberWithCommas
} from '../../functions';
import {
    addInfopointsBlock,
    addFavoritesBlock, closeOptionsCard, createHeader,
} from "./cardsFunctions";
import { changeLangToCurrent, getCurrentLang, getCurrentLangDirection } from '../language/langSwitcher';
import {Buildings, cardsData, isMobile, isTablet, projectMode, settingsData} from '../../settings';
import {applyNow} from "../apply-now/applyNow";
import {applyNowContent} from "../apply-now/applyNowContent";
import {renderUpdateValuesOnDemand} from "../../app";
import axios from "axios";
import {hideTooltip} from "../flatTooltip/flatTooltip";
import {
    draggableOptionsCardBlock,
    fadeInOptionsCardAnimation,
    fixedElementsPositionDurScrolling,
    moveOptionsCardTimeout,
    openOptionsCardAnimation,
} from "./cardsAnimation";
import {CardTypes} from "../../common";
import {createIconsArray} from "./cardsConfig";
import gsap from 'gsap';
import {SwipeScript} from "../controls/swipe";
import printJS from "print-js";
import {zoom} from "../../libs/directive";
import {findSimilarApartments, recreateBlockWhenLangSwitch} from "../search/similarSearch";
import {analytics} from "../analytics/analytics";
import {addConferenceBuyNow} from "../apply-now/buyNow";
import { setActiveLordIcon, setLordIcon } from '../../lordicon';
import Swiper, { Pagination, EffectCube, Navigation } from 'swiper';
import { reduceImage } from '../widgets/gallery/galleryDesktop';
import {Building} from "../building/Building";


let optionCardGallery = null;

export const openOptionsCard = (object = settingsData.lastClickedFlat.userData.crm_data, settings = config,params ={}) => {
    projectMode.Pagination.paginate({source: 'openOptionsCard', flatId: object.bmbyPropID || settingsData.lastClickedFlat.userData.name});

    analytics('option card', object);

    // if (settingsData.doubleClick) {
    //     settingsData.doubleClick = false;
    // }

    if (!isMobile) cardsData.cardMode.isAmenities = settingsData.lastClickedFlat.userData?.customSelection;

    hideTooltip();

    const isCardOpened = document.querySelector(`.${CardTypes.Options}-card`);
    isCardOpened && document.body.removeChild(isCardOpened);

    createOptionsCard(object, settings, isMobile,params);

    const closeButton = document.querySelector(`.${CardTypes.Options}-card__close-btn`);
    closeButton.addEventListener('click', closeHandler);

    // if (cardsData.cardMode.isAmenities || settingsData.isDesktopMode) return;
    //
    // const isIosApp = getUrlParam('type') === 'ios';
    // if (isIosApp) return;
    //const refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?prop=' + object.bmbyPropID;
    //window.history.replaceState({path: refresh}, '', refresh);


};

export const createOptionsCard = (object, settings, isMobile,params = {}) => {
    /**
     * Create card div with animation
     */
    const cardBox = createElements('div', [`${CardTypes.Options}-card`, 'non-canvas'], document.body);
    cardBox.setAttribute('data-engineid', object.engineId);
    cardsData.cardMode.isUnavailable = object.status !== 'Available';
    /**
     * CARD Blocks
     */
    cardsData.cardMode.isAmenities && cardBox.classList.add(`${CardTypes.Amenities}-card`);
    const closeButton = createElements('button', [`${CardTypes.Options}-card__close-btn`, 'non-canvas', 'close-cards-btn', 'icon-close'], document.querySelector(`.${CardTypes.Options}-card`));
    const plansBlock = addPlansBlock(cardBox, object, settings, isMobile);
    const cardBoxData = createElements('div', [`${CardTypes.Options}-card__data`], cardBox);

    if (!params['disableAnimation']){
        !isMobile && openOptionsCardAnimation();
        !isMobile && moveOptionsCardTimeout(object);
    }

    // settingsData.isDesktopMode && moveOptionsCardTimeout();

    createHeader(object, cardBoxData, settings, CardTypes.Options);
    // addDragElement(cardBoxData);
    !isMobile && addDragElement(cardBoxData);
    const infoPointsBlock = addInfopointsBlock(object, cardBoxData, CardTypes.Options, settings);

    /**
     * Description block for mobile
     */
    // isMobile && !settingsData.isLandscape && createDescriptionBlock();

    /**
     * Options Buttons
     */
    const optionsButtonParent = isMobile ? cardBox : cardBoxData;
    const cardOptionsButton = createElements('div', [`${CardTypes.Options}-card__data-options-buttons`], optionsButtonParent);

    config.features.apartments.isFavorite && !cardsData.cardMode.isAmenities && addFavoritesBlock(object, cardOptionsButton, CardTypes.Options);
    // config.features.apartments.isSharing && isMobile && addShareButton();
    // config.features.apartments.isDownload && !isMobile && addDownloadButton();

    /**
     * Apply now
     */

    if (!isMobile) {
        const buttonsContainer = createElements('div', [`${CardTypes.Options}-card__header-buttons`], document.querySelector(`.${CardTypes.Options}-card__header`));
        !settingsData.isDesktopMode && addApplyNow('');
        settingsData.isConferenceHost && addConferenceBuyNow(CardTypes.Options, buttonsContainer);
    }

    /**
     * Mobile customisation
     */
    if (isMobile) {
        addScrollPlug(cardBox);
        fadeInOptionsCardAnimation(2);
        fixedElementsPositionDurScrolling();
    }

    if (!isMobile) {
        SwipeScript(cardBoxData);
        if (document.querySelector('html').getAttribute('dir') === 'rtl' || settingsData.isDesktopMode) {
            cardBoxData.addEventListener('swiped-right', swipeRightDataHandler);
            cardBoxData.addEventListener('swiped-left', swipeLeftDataHandler);

        } else {
            cardBoxData.addEventListener('swiped-right', swipeLeftDataHandler);
            cardBoxData.addEventListener('swiped-left', swipeRightDataHandler);
        }
        cardBoxData.addEventListener('click', draggableOptionsCardBlock);
    }

    findSimilarApartments();
};

export const reopenDataBlockAfterResize = () => {
    const object = settingsData.lastClickedFlat.userData.crm_data;
    const showPrice = config.crmProjectSettings.property.settings.displayPrice !== 'hide' || settingsData.isConferenceHost;

    !cardsData.cardMode.isAmenities && document.querySelector(`.${CardTypes.Options}-card__apply-now-btn`).remove();
    document.querySelector(`.${CardTypes.Options}-card__header`).remove();
    createHeader(object, document.querySelector(`.${CardTypes.Options}-card__data`), config, CardTypes.Options, 'resize');
    fixedElementsPositionDurScrolling();

    if (!cardsData.cardMode.isAmenities && object.status === "Available" && object.salePrice !== 0 && showPrice) {
        const priceValue = document.querySelector(`.${CardTypes.Options}-card__price-value`);
        const price = numberWithCommas(Math.floor(object.salePrice));
        priceValue.innerHTML = price;
    }
    recreateBlockWhenLangSwitch();

}

const addDragElement = (parent) => {
    const drag = createElements('div', [`${CardTypes.Options}-card__data-drag`], parent);

    return drag;
}

export const setWidthOfCardDependingOnMenu = (card = document.querySelector(`.${CardTypes.Options}-card`)) => {
    const menuWidth = document.querySelector('.aside__container').getAttribute('data-initial-width');
    const desktopMode = settingsData.isDesktopMode;
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    const width = window.innerWidth - menuWidth;
    //const height = window.innerHeight - document.querySelector('.aside__container').getBoundingClientRect().height;

    if (desktopMode) {
        //card.style.height = `${height}px`;
        // card.style.width = `${width}px`;
        card.style.right = `0`;
        card.style.left = `initial`;
    } else if (rtl) {
        card.style.width = `${width}px`;
        card.style.right = `initial`;
        card.style.left = `0`;
    } else {
        card.style.width = `${width}px`;
        card.style.right = `0`;
        card.style.left = `initial`;
    }
}

const addScrollPlug = (cardBox) => {
    if (!document.querySelector(`.${CardTypes.Options}-card__scroll-plug`) && isMobile) {
        createElements('span', [`${CardTypes.Options}-card__scroll-plug`], cardBox);
    }
}

const addApplyNowButton = (cardBoxData, resize, card = CardTypes.Options) => {
    cardBoxData = !settingsData.isLandscape && isMobile ? document.querySelector(`.${card}-card__title-box`) : cardBoxData;
    const button = createElements(
        'button',
        [`${card}-card__apply-now-btn`, 'language-string', 'apply-now', 'button'],
        resize && settingsData.isLandscape ? document.querySelector(`.${card}-card__header`) : cardBoxData,
        resize && settingsData.isLandscape ? 'afterend' : 'beforeend',
        {
        data: 'data-dictionary',
        value: 'Apply now',
        }
        );
    button.innerHTML = changeLangToCurrent('Apply now');
    button.addEventListener('click', applyNowHandler);
};

export const addApplyNow = (cardBoxData, resize, card) => {
    if (!cardBoxData) {
        cardBoxData = document.querySelector(`.${CardTypes.Options}-card__header-buttons`);
    }
    !cardsData.cardMode.isAmenities && addApplyNowButton(cardBoxData, resize, card);
}

const addPlansBlock = async (cardBox, object, settings, isMobile) => {
    const plansBlock = createElements('div', [`${CardTypes.Options}-card__plans-box`], cardBox);
    const previewBlock = createElements('div', [`${CardTypes.Options}-card__plans-box_preview`], plansBlock);
    const plansData = addPlansData(object, settings);

    if (!config.features.apartments.hasPadding) {
        previewBlock.classList.add('is-padding');
    }

    const plansButtons = createElements('div', [`${CardTypes.Options}-card__plans-box_buttons`], plansBlock);
    let sortingArray = plansData.reduce((arr, data) => {
        const elem = data.type === '360' ? data : null;
        elem ? arr.unshift(data) : arr.push(data);

        return arr;
    }, []);

    if (object['custom-field-source'] === 'info-points') {
        sortingArray = shift2dViewInFront(sortingArray);
        object['custom-field-source'] = null;
    }


    await addPlansButtons(object, settings, isMobile, sortingArray);
    setPlansAndTours(sortingArray);
    addDisclaimer(sortingArray);
    setPlugToPreviewBlock();
    togglePlans();

    return sortingArray;


    function shift2dViewInFront(arr) {
        arr.reverse();
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].type === '2D') {
                const temp = arr[i];
                arr.splice(i, 1);
                arr.push(temp);
                arr.reverse();
                break;
            }
        }
        return arr;
    }
};

const addPlansButtons = async (object, settings, isMobile, plansData) => {
    const buttonsBlock = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);

    for (const button of plansData) {
        if (button.isActive && button.crmData) {
            const icon = button.icon ? button.icon : '';
            // const buttonText = button.title[0].value ? button.title[0].value : '';
            const buttonText = button.type;
            const btn = createElements('button', [`${buttonText}`, `${CardTypes.Options}-card__plans-box_buttons-btn`], buttonsBlock);
            // btn.setAttribute('data-dictionary', buttonText);
            btn.setAttribute('data-type',buttonText);
            // icon && btn.classList.add(icon);

            if (button.type === '360Sample') {
                btn.classList.add('language-string');
                btn.setAttribute('data-lord-lang', 'Sample');
                btn.innerHTML = changeLangToCurrent('Sample');
                setLordIcon('360View',btn,{
                    stroke: 90,
                    trigger: 'hover'
                },'afterbegin');
            } else {
                if (button.icon) {
                    btn.removeAttribute('data-dictionary');
                    btn.classList.remove('language-string');
                    btn.innerHTML = '';
                    setLordIcon(buttonText,btn,{
                        stroke: 90,
                        trigger: 'hover'
                    })
                } else {
                    setLordIcon(buttonText,btn,{
                        stroke: 90,
                        trigger: 'hover'
                    })
                    // btn.innerHTML = buttonText;
                }
            }

            // addActiveClassToBtnTogglersPlans();
        }
    }

    addActiveClassToBtnTogglersPlans();

    settingsData.isDesktopMode && addBackButton();
};

const addLoader = (isFetching) => {
    const block = document.querySelector(`.${CardTypes.Options}-card__plans-box_preview`);

    if (isFetching && !document.querySelector(`.${CardTypes.Options}-card__plans-box_preview-loader`)) {
        const loader = createElements('div', [`${CardTypes.Options}-card__plans-box_preview-loader`], block)
        loader.innerHTML = '<div></div><div></div><div></div><div></div>'
    }
}

const addDisclaimer = (plansData, target = false) => {
    return;

    const togglerButton = target ? target : document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons-btn`);

    if (!togglerButton) return;

    const disclaimerData = plansData.find(data => data.title[0].value === togglerButton.classList[0]).disclaimer;

    if (!disclaimerData.he && !disclaimerData.en) {
        return;
    }

    const container = document.querySelector(`.${CardTypes.Options}-card__plans-box_disclaimer`);
    const plansBlock = document.querySelector(`.${CardTypes.Options}-card__plans-box`);
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';

    if (container) {
        const disclaimer = document.querySelector(`.${CardTypes.Options}-card__plans-box_disclaimer-text`);
        disclaimer.innerHTML = disclaimerData;
    } else {
        const disclaimerBlock = createElements('div', [`${CardTypes.Options}-card__plans-box_disclaimer`], plansBlock);
        const disclaimer = createElements('div', [`${CardTypes.Options}-card__plans-box_disclaimer-text`], disclaimerBlock);
        const disclaimerOpacity = createElements('div', [`${CardTypes.Options}-card__plans-box_disclaimer-opacity`], disclaimerBlock);
        disclaimer.innerHTML = rtl ? disclaimerData.he : disclaimerData.en;
        // disclaimer.innerHTML = disclaimerData; // for
        changeBorderRadius(disclaimerOpacity);
    }
}

const setPlansAndTours = (plansData) => {
    const block = document.querySelector(`.${CardTypes.Options}-card__plans-box_preview`);
    const togglerButton = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons-btn`);
    const loader = document.querySelector(`.${CardTypes.Options}-card__plans-box_preview-loader`);

    loader && block.removeChild(loader);
    createPlanPreviewElement(togglerButton, block, plansData, isMobile);
}

const createPlanPreviewElement = (element, block, plansData) => {
    if (!plansData || !element) return;

    const print = document.querySelector(`.${CardTypes.Options}-card__print-btn`);

    if (element && element.classList.contains('print')
        || element && element.classList.contains('download')
        || element.classList.contains('plan-back_btn')) {
        return;
    }

    if (element.getAttribute('data-type') === 'gallery'){
        block.innerHTML = '';
        block.classList.remove('is-padding');
        block.classList.remove('zoom');

        const pictures = plansData.find(assets => assets.type === 'gallery').crmData;

        optionCardGallery = new OptionsCardGallery(block,pictures);
        optionCardGallery.create();

        return;
    }

    const src = new URL(plansData.find(data => data.type === element.getAttribute('data-type')).crmData);
    block.innerHTML = '';

    if (src.origin.match(/matterport/g)){
        src.searchParams.append('play','1');

        if (isMobile){
            src.searchParams.append('brand','0');
            src.searchParams.append('title','0');
        }
    }

    const plan = createElements(
        element.getAttribute('data-type') === '2D' ? 'img' : 'iframe', [`${CardTypes.Options}-card__plans-box_preview-content`, `plan-${element.getAttribute('data-type')}`], block, 'beforeend', {
            data: 'src',
            value: src,
        });


    if (element.getAttribute('data-type') === '2D') {
        if (!print) {
            config.features.apartments.isPrint && !isMobile && !settingsData.isDesktopMode && addPrintButton();
            // cardsData.isPrint && !isMobile && !settingsData.isDesktopMode && addDownloadButton(src);
        }
        block.classList.add('zoom');
        addActionsWith2DPlan(element.classList[0], element, isMobile);
        !config.features.apartments.hasPadding && !block.classList.contains('is-padding') && block.classList.add('is-padding');
    } else {
        if (block.classList.contains('is-padding')) {
            block.classList.remove('is-padding');
        }

    }

}

const setPlugToPreviewBlock = () => {
    const block = document.querySelector(`.${CardTypes.Options}-card__plans-box_preview`);

    if (!document.querySelector(`.${CardTypes.Options}-card__plans-box_preview`).hasChildNodes()) {
        const emptyPlans = createElements('div', [`${CardTypes.Options}-card__plans-box_preview-empty`], block);
        // TODO translate to hebrew
        emptyPlans.innerHTML = 'Content will be soon';
    }
}

const addActiveClassToBtnTogglersPlans = () => {
    const button = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons-btn`);
    const buttonList = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);

    if (!button || !buttonList) return;

    const buttonsAmount = buttonList.childNodes;

    button.classList.add('active');

    setActiveLordIcon(button.getAttribute('lord-icon-name'),buttonList);

    // for button border style
    if (isMobile) {
        if (buttonsAmount.length > 1) {
            buttonsAmount[0].style.borderRadius = '4px 0 0 4px';
            buttonsAmount[buttonsAmount.length - 1].style.borderRadius = '0 4px 4px 0';
        } else if (buttonsAmount.length === 1) {
            buttonsAmount[0].style.borderRadius = '4px';
        }
    }
}

const togglePlans = () => {
    const btnBlock = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);

    btnBlock.addEventListener('click', togglePlansHandler);
};

const addPlansData = (object) => {
    const settingArray = config.property.buttons;
    const iconsArray = createIconsArray();
    let flag360;

    let plansArray = settingArray.map(data => {
        // const title = iconsArray.find(icon => icon.title === data.title[0].value).crmTitle;
        const dataConfig = iconsArray.find(prop => prop.type === data.type);

        let obj = {
            type: data.type,
            // title: data.title.find(title => title.lang === getCurrentLang()).value,
            // crmData: isMobile && data.type === "2D"
            //     ? object.assets.plan2DVertical
            //     : object.assets[dataConfig.crmTitle],

            crmData: object.assets[dataConfig.crmTitle],
            // crmData: iconsArray.find(icon => icon.title === data.title[0].value).plan, // for testing
            // icon: iconsArray.find(icon => icon.title === data.title[0].value).icon,
            icon: dataConfig.icon,
            // disclaimer: data.disclaimer.find(text => text.lang === getCurrentLang()).value,
            // disclaimer: iconsArray.find(icon => icon.title === data.title[0].value).disclaimer,
            isActive: data.active,
        };

       /* Remove when crm has been updated */
        // if (!flag360){
        //     flag360 = data.type === "360" && obj.crmData;
        // }

        // console.log(data);
        if (data.type === '360' && obj.crmData)
            flag360 = true;

      /*  ************   */

        return obj;
    });


    /* Remove when crm has been updated */
    // if (!flag360){
    //
    //     const sample360 = {
    //         type: '360Sample',
    //         crmData: object.assets.sample360,
    //         icon: 'icon-360',
    //         disclaimer: '',
    //         isActive: true,
    //     };
    //
    //     plansArray.push(sample360);
    // }

    if (flag360)
        plansArray = plansArray.filter(btn => btn.type !=='360Sample');

    /*  ************   */

    return plansArray;
};

const addActionsWith2DPlan = (buttonText, btn) => {
    if (buttonText === '2D') {
        zoom();
        btn.classList.add('active');
    }
};

const addShareButton = () => {
    const button = createElements('button', [`${CardTypes.Options}-card__share-btn`, 'icon-share', `${CardTypes.Options}-item`], document.querySelector('.options-card__data-options-buttons'));
};

const addDownloadButton = (src) => {
    if (document.querySelector('.download')) return;

    const parent = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
    const downloadBtn = createElements('button', [`${CardTypes.Options}-card__plans-box_buttons-btn`, 'download', 'icon-download'], parent);

    downloadBtn.addEventListener('click', () => download2DPlan(src));
};

const download2DPlan = (src) => {
    const propNum = settingsData.lastClickedFlat.userData.crm_data.propNum;
    const projectName = config.projectTitle.split(" ").join("").split(",").join("_");

    axios({
        url: src,
        method: 'GET',
        responseType: 'blob'
    })
        .then((response) => {
            const url = window.URL
                .createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${projectName}_${propNum}.png`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
}

const addPrintButton = () => {
    if (document.querySelector('.print')) return;

    const parent = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
    // const printBtn = createElements('button', [`${CardTypes.Options}-card__plans-box_buttons-btn`, 'print', 'icon-print'], parent);
    const printBtn = createElements('button', [`${CardTypes.Options}-card__plans-box_buttons-btn`, 'print'], parent);

    setLordIcon('print',printBtn,{
        stroke: 90,
        trigger: 'hover'
    });

    printBtn.addEventListener('click', print2DPlan);
};

const print2DPlan = () => {
    const img = document.querySelector(`.${CardTypes.Options}-card__plans-box_preview-content`);
    printJS(img.src, 'image');
    // dragAndDrop(document.querySelector('.options-card__plans-box_preview'), img);
}

const addBackButton = () => {
    if (document.querySelector('.plan-back_btn')) return;

    const parent = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
    const backBtn = createElements('button', [`${CardTypes.Options}-card__plans-box_buttons-btn`, 'plan-back_btn', 'icon-back'], parent);

    backBtn.addEventListener('click', () => {
        const card = document.querySelector(`.${CardTypes.Options}-card`);
        if (card) {
            projectMode.Pagination.paginate({source: 'cardsBackButton'});
            closeOptionsCard();
            return;
        }
    });
}

export const changeScreenOrientation = () => {
    const planBlock = document.querySelector(`.${CardTypes.Options}-card__plans-box`);
    const dataBlock = document.querySelector(`.${CardTypes.Options}-card__data`);
    const descriptionBlock = document.querySelector(`.${CardTypes.Options}-card__description`);

    if (settingsData.isLandscape && descriptionBlock) {
        descriptionBlock.remove();
    } else if (!settingsData.isLandscape && !descriptionBlock) {
        createDescriptionBlock();
    }
};

const createDescriptionBlock = () => {
    const descriptionBlock = createElements('div', [`${CardTypes.Options}-card__description`], document.querySelector(`.${CardTypes.Options}-card`));
    const descriptionParagraph = createElements('p', [`${CardTypes.Options}-card__description-content`], descriptionBlock);

    descriptionParagraph.innerHTML = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
}





/**
 * Handlers
 */

export const closeHandler = () => {
    projectMode.Pagination.paginate({source: 'flatCloseButtonHandler'});
    closeOptionsCard();
}

export const applyNowHandler = () => {
    if (settingsData.showApplyNow) {
        applyNow(document.body, applyNowContent, false, ['print-btn', 'popup-btn.icon-close'], settingsData.lastClickedFlat);
    }
}

export const togglePlansHandler = (e) => {
    e.stopPropagation();

    let target;

    if (e.target.tagName === 'LORD-ICON'){
        target = e.target.parentElement;
    } else {
        target = e.target;
    }

    const plansData = addPlansData(settingsData.lastClickedFlat.userData.crm_data, config);
    const sortingArray = plansData.reduce((arr, data) => {
        const elem = data.type === '360' ? data : null;
        elem ? arr.unshift(data) : arr.push(data);

        return arr;
    }, []);

    removeOptionsCardGallery();

    const block = document.querySelector(`.${CardTypes.Options}-card__plans-box_preview`);
    block.removeAttribute('style');

    if (target === document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`)
        || target.classList.contains('print')
        || target.classList.contains('download')
        || target.classList.contains('plan-back_btn')) return;
    const btnList = document.querySelectorAll(`.${CardTypes.Options}-card__plans-box_buttons-btn`);

    createPlanPreviewElement(target, block, sortingArray, isMobile);
    addDisclaimer(sortingArray, target);

    if (!target.classList.contains('2D')) {
        document.querySelector('.print') && document.querySelector('.print').remove();
        document.querySelector('.download') && document.querySelector('.download').remove();
        document.querySelector(`.${CardTypes.Options}-card__plans-box_preview`).removeAttribute('style');
    }

    // if (isMobile && e.target.dataset.dictionary === 'Sample'){
    //     return;
    // }

    btnList.forEach(btn => {
        if (btn.classList.contains('active')) {
            btn.classList.remove('active');
            btn.removeAttribute('disabled');
            setActiveLordIcon(undefined,document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`));
        }
    });

    target.setAttribute('disabled', 'disabled');
    target.classList.add('active');
    setActiveLordIcon(target.getAttribute('lord-icon-name'),document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`));
}

const swipeRightDataHandler = (e) => {
    draggableOptionsCardBlock(e, 'close');
}

const swipeLeftDataHandler = (e) => {
    draggableOptionsCardBlock(e, 'open');
}

/**
 * Remove all listeners
 */

export const removeOptionCardListeners = () => {
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);
    const closeButton = document.querySelector(`.${CardTypes.Options}-card__close-btn`);
    const cardBoxData = document.querySelector(`.${CardTypes.Options}-card__data`);
    const applyNowButton = document.querySelector(`.${CardTypes.Options}-card__apply-now-btn`);
    const btnBlock = document.querySelector(`.${CardTypes.Options}-card__plans-box_buttons`);
    const checkbox = document.querySelector(`.${CardTypes.Options}-card__favorite-checkbox`);
    const applyNowConf = document.querySelector(`.${CardTypes.Options}-card__apply-now_conf`);

    closeButton && closeButton.removeEventListener('click', closeHandler);
    applyNowButton && applyNowButton.removeEventListener('click', applyNowHandler);
    btnBlock.removeEventListener('click', togglePlansHandler);
    cardBoxData.removeEventListener('swiped-right', swipeRightDataHandler);
    cardBoxData.removeEventListener('swiped-right', swipeLeftDataHandler);
    cardBoxData.removeEventListener('swiped-left', swipeLeftDataHandler);
    cardBoxData.removeEventListener('swiped-left', swipeRightDataHandler);
    cardBoxData.removeEventListener('click', draggableOptionsCardBlock);

    if (isMobile) {
        optionsCard.removeEventListener('scroll', scroll);
    }

    if (applyNowConf) {
        applyNowConf.removeEventListener('click', applyNowConfHandleClick);
    }
}

export function renameTowerNameInOptionCard () {
    if (Buildings.getBuildingsInfoLength() <= 1) return;

    const card = document.querySelector(`.${CardTypes.Options}-card`);
    if (!card) return;

    const towerName = card.querySelector('.card__tower-name');

    const activeBuildingTowerName = Buildings.getActiveBuilding().info.towerName;

    let name;

    if (Array.isArray(activeBuildingTowerName)){
        name = activeBuildingTowerName.find(name => name.lang === getCurrentLang()).value;
    } else {
        name = activeBuildingTowerName;
    }

    towerName.textContent = name;
}


export function resizeOptionsCardGallery () {
    if (optionCardGallery !== null){
        optionCardGallery?.update();
    }
}

export function removeOptionsCardGallery () {
    if (optionCardGallery !== null){
        optionCardGallery.remove();
        optionCardGallery = null;
    }
}

export function changeOptionsCardGalleryDirection () {
    if (optionCardGallery){
        optionCardGallery.changeDirection();
    }
}

export class OptionsCardGallery {
    constructor (container, picturesArray) {
        this.container = container;
        this.picturesArray = picturesArray;
        this.swiper = null;
        this.galleryContainer = null;
    }

    create(){
        this.galleryContainer = createHtmlElement(this.container,'','div',['swiper','options__card__gallery']);
        this.galleryContainer.setAttribute('dir',getCurrentLangDirection());
        const galleryWrapper = createHtmlElement(this.galleryContainer,'','div',['options__card__gallery__wrapper','swiper-wrapper']);

        this.picturesArray.forEach((picture,index) => {
            let url;

            if (isMobile || isTablet){
                url = reduceImage(picture,{
                    width: 1024,
                    quality: 75
                });
            } else {
                url = reduceImage(picture,{
                    width: 2048,
                    quality: 75
                });
            }

           const imgContainer = createHtmlElement(galleryWrapper,'','div',['options__card__gallery__img__container','swiper-slide']);
           const img = createHtmlElement(imgContainer,'','img',['options__card__gallery__img']);
           // img.setAttribute('data-src',picture);
           img.src = url;
           img.alt = `Picture-${index}`;
           img.onload = ()=> {
               preloaderContainer.remove();
           };
           const preloaderContainer = createHtmlElement(imgContainer,'','div',['options__card__gallery__img__preloader']);
           const preloader = createHtmlElement(preloaderContainer,'','div',['swiper-lazy-preloader', 'swiper-lazy-preloader-white']);

        });

        const pagination = createHtmlElement(this.galleryContainer,'','div',['options__card__gallery__pagination','swiper-pagination']);

        const nextBtn = createHtmlElement(this.galleryContainer,'','div',['options__card__gallery__navigation-btn','swiper-button-next','icon-right1']);
        const prevBtn = createHtmlElement(this.galleryContainer,'','div',['options__card__gallery__navigation-btn','swiper-button-prev','icon-left1']);

        Swiper.use([Pagination,EffectCube,Navigation]);

        this.swiper = new Swiper('.options__card__gallery',{
            // lazy: true,
            effect: 'cube',
            loop: this.picturesArray.length > 1,
            spaceBetween: 30,
            pagination: {
                el: '.options__card__gallery__pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: ".options__card__gallery__navigation-btn.swiper-button-next",
                prevEl: ".options__card__gallery__navigation-btn.swiper-button-prev",
            },
        });

    }

    update(){
        this.swiper?.update();
    }

    remove(){
        this.galleryContainer?.remove();
        this.galleryContainer = null;
        this.swiper = null;
    }

    changeDirection(){
        if (!this.swiper) return;
        this.remove();
        this.create();
    }
    
}
